import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);

export function showDuration(seconds) {
    if (seconds <= 1) return seconds + 's'
    seconds = Number(seconds);
    let y = Math.floor(seconds / (365*12*30*24*3600));
    let M = Math.floor(seconds / (30*3600*24));
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor(seconds % (3600 * 24) / 3600);
    let m = Math.floor(seconds % 3600 / 60);
    let s = Math.floor(seconds % 60);

    // let MDisplay = M > 0 ? d + (d == 1 ? "M " : "M ") : "";
    let dDisplay = d > 0 ? d + (d == 1 ? "d " : "d ") : "";
    let hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    let mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    let sDisplay = s > 0 ? s + (s == 1 ? "s " : "s ") : "";
    // return y + dDisplay + hDisplay + mDisplay + sDisplay;
    return moment.duration(seconds, "seconds").format("y[y] M[m] d[d] h[H] m[M] s[S]")
}

export function detectDir(str, return_align = false) {
    let p = /^[\u0600-\u06FF\s]+$/;
    let dir = "ltr"
    let align = "left"
    if (p.test(str)) {
        dir = "rtl"
        align = "right"
    }
    if (return_align)
        return align
    else return dir
}

export function createDataPost(param){
let data = {}
    let cParam = Object.keys(param)
    cParam.forEach(item => {
        if((param[item] && param[item].length > 0) || typeof param[item] === 'number') {
            data[item] = param[item]
        }
    })
    return data;
}

export const showFileName = (fileName , countChar = 28) => {
    if(fileName.length > countChar){
        return fileName.substr(0,countChar/2) +'...'+fileName.substr(fileName.length - countChar/2,fileName.length - 1);
    }
    return fileName;
}

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}
